import classNames from "classnames";
import React from "react";

import { Nullable } from "../../common/types/types";
import SOKLogo from "../../components/Logo/SOKLogo";
import { IStallMode } from "../../contexts/ConfigContext/types";
import "./SplashScreen.scss";
import "./SplashScreen_sok.scss";

export interface ISplashScreenProps {
	stallMode: Nullable<IStallMode>;
	isVisible: boolean;
	onAnimationEnd?: () => void;
	"data-testid"?: string;
}

const SplashScreen: React.FC<ISplashScreenProps> = ({
	stallMode,
	isVisible,
	onAnimationEnd,
	"data-testid": dataTestId,
}) => {
	return (
		<div
			className={classNames("SplashScreen", {
				FadeOut: !isVisible,
			})}
			onAnimationEnd={onAnimationEnd}
			data-testid={dataTestId || "splash-screen"}
		>
			<div className="SplashContent">
				<div className="LogoContainer">
					<SOKLogo className="Logo" data-testid="splash-logo" />
				</div>
				<div className="LoaderContainer" />
			</div>
		</div>
	);
};

export default SplashScreen;
